import { Box, Grid, Paper, Typography } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { translateFunc } from '../../../Helpers/translateFunc';
import { useState } from 'react';
import MapAssets from '../../../Components/Generic/MapAssets';

export const ReportsTables = ({ t, data, globalContext, selectedAsset }) => {
    const [pageSize, setPageSize] = useState(5)

    const renderCellValue = (name, value) => {
        const isLabeledValue =
            value &&
            typeof value === 'object' &&
            'label' in value &&
            'key' in value;

        if (isLabeledValue) {
            const attribute = globalContext.getSessionDataByKey('models')?.[selectedAsset.id]?.attributes?.find(att => att.name === name);

            return attribute?.type !== 'date'
                ? translateFunc(t, `basicFormStepByStep.fieldTranslate.${attribute.type}.${name}.${value.key}`, value.label)
                : value.label;
        }

        return value;
    };

    const renderDatagrid = (rows, columns) => {
        return (
            <DataGrid
                className="data-grid-custom-pagination"
                columns={columns}
                rows={rows}
                pagination
                pageSize={pageSize}
                rowsPerPageOptions={[5, 10, 25]}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                disableSelectionOnClick
                rowHeight={30}
                headerHeight={35}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    '& .MuiDataGrid-columnHeaders': {
                        backgroundColor: 'primary.main',
                        color: 'background.default',
                        fontWeight: 'bold',
                        fontSize: '0.8rem',
                    },
                    '& .MuiDataGrid-row': {
                        fontSize: '0.75rem',
                    },
                    '& .MuiDataGrid-cell': {
                        fontSize: '0.75rem'
                    },
                    '& .MuiDataGrid-footerContainer': {
                        minHeight: '30px',
                        height: '30px',
                        paddingTop: 0,
                        paddingBottom: 0,
                    },
                    '& .MuiTablePagination-toolbar': {
                        minHeight: '30px !important',
                        height: '30px !important',
                    },
                    '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                        fontSize: '0.75rem',
                        lineHeight: 1,
                    },
                    '& .MuiInputBase-root': {
                        fontSize: '0.75rem',
                    },
                    '& .MuiTablePagination-root': {
                        overflow: 'hidden',
                    },
                }}
            />
        )
    }

    return (
        <Grid container spacing={2} sx={{ mb: 2 }}>
            {data.map((table, index) => {
                switch (table.type) {
                    case 'table': {
                        const columns = table.columns.map((column) => ({
                            field: column.name,
                            headerName: translateFunc(t, `basicFormStepByStep.placeholdersTranslate.${column.label}`, column.label),
                            minWidth: 200,
                            renderCell: (params) => renderCellValue(column.name, params.value),
                        }));
        
                        const rows = table.value.map((row, idx) => ({
                            id: idx,
                            ...row
                        }));
        
                        return (
                            <Grid 
                                item 
                                xs={12}
                                lg={table.totalWidth ? false : 6}
                                key={index}
                            >
                                {table.title ? (
                                    <Box sx={{ border: 1, borderColor: 'grey.300', borderRadius: 3, overflow: 'hidden', p: 2 }}>
                                        <Typography
                                            align="center"
                                            fontWeight="bold"
                                            sx={{ mb: 1 }}
                                        >
                                            {t(`controlPanel.titles.${table.title}`)}
                                        </Typography>
                                        <Paper variant="outlined" sx={{ borderRadius: 3, overflow: 'hidden', height: 218 }}>
                                            {renderDatagrid(rows, columns)}
                                        </Paper>
                                    </Box>
                                ) : (
                                    <Paper variant="outlined" sx={{ borderRadius: 3, overflow: 'hidden', height: 218 }}>
                                    {   renderDatagrid(rows, columns)}
                                    </Paper>
                                )}
                            </Grid>
                        );
                    }
                    case 'map': {
                        return (
                            <Grid item xs={12} key={index}>
                                <Box sx={{ border: 1, borderColor: 'grey.300', borderRadius: 3, overflow: 'hidden' }}>
                                    <MapAssets assetList={table.value}/>
                                </Box>
                            </Grid>
                        )
                    }
                    default:
                        break;
                }
            })}
        </Grid>
    );
};
